<template>
  <div id="app">
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>

<script>
import './assets/style/responsive_base.css'
import Header from './components/header.vue'
import Footer from './components/footer.vue'

export default {
  name: 'app',
  components: {
    'app-header': Header,
    'app-footer': Footer
  },
  watch: {
    '$route': function (to, from) {
      if (to.path !== from.path) {
        const recaptchaElement = document.getElementsByClassName('grecaptcha-badge');
        while (recaptchaElement.length) {
          recaptchaElement.item(0).remove()
          }
      }
    }
  }
}
</script>

<style>
/*
#app {
  max-width: 640px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 1.5em;
}
@media all and (-ms-high-contrast:none) {
  #app {
    width: 100%;
  }
}

img {
  max-width: 100%;
  height: auto;
}
body{
  font-family:'メイリオ', Meiryo, 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', sans-serif !important;
  display: flex;
  flex-flow: column;
  min-height: 100vh;
  margin-top: 0px;
}
div.sectionheader {
  height: auto;
  font-size: 0.9em;
}
div.descriptions {
  height: auto;
  padding: 0px 10px;
  font-size: 0.8em;
}
div.sectionCenter{
  margin-left:auto;
  margin-right:auto;
  word-wrap: break-word;
  white-space: normal;
  display: flex;
  justify-content: space-between;
}
div.sectionHeader{
  margin-left: auto;
  margin-right: auto;
  font-size:12.0pt;
  font-weight:700;
  vertical-align:middle;
  padding-top:5px;
  padding-bottom:5px;
  padding-left:5px;
  border-bottom: solid 4px #0099ff;
  font-family:'メイリオ', Meiryo, 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', sans-serif !important;
}
footer{
  text-align: center;
  padding-top: 10px;
  margin-top: 10px;
}
h2,.blueWord{
  color: #0099ff;
}
h1{
  display:block;
  line-height: 160%;
  font-size: 160%;
  color: #ffffff;
  background-color: #0099ff;
  font-weight: 900;
  text-align: left;
  margin: auto;
  padding: auto;
}
input[type="text"],input[type="password"],textarea{
  border: 1px solid black;
  width: stretch;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  background-color: rgb(255, 255, 255);
  font-family: SFS, Arial, sans-serif;
  box-sizing: border-box;
  -webkit-appearance: none;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(216, 221, 230);
  border-radius: 4px;
  font-size: 16px;
  transition: all 0.1s ease 0s;
  margin: 5px 5px 15px 5px;
  padding: 12px;
}
.form-label{
  font-size:0.8em;
  margin-left:5px;
}
.btn{
  -webkit-appearance: none;
  width: 90%;
  color: #ffffff;
  background-color: #0099ff;
  background: #0099ff;
  border-radius: 0px;
  padding:10px;
  font-size: 1.0em;
}
.btn-container{
  display: flex;
  margin:10px;
  padding: 12px;
  justify-content: center;
}
.btn-disabled {
  opacity: 0.45; 
  cursor: not-allowed;
}
.link-container{
  display: flex;
  justify-content: center;
  align-items: center;
}
.validMsg{
  color:red;
  text-align:center;
  margin:10px;
}
.form-control{
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  width: 98%;
}
.form-control:focus {
  outline: none;
  border-color: rgb(77, 144, 254);
  box-shadow: 0 0 2px rgb(77, 144, 254);
}
*/
</style>
